'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true,
});
exports.default = void 0;
var _react = _interopRequireDefault(require('react'));
var _internal = require('@atlaskit/icon-file-type/internal');
function _interopRequireDefault(e) {
	return e && e.__esModule ? e : { default: e };
}
const Presentation24Icon = (props) =>
	/*#__PURE__*/ _react.default.createElement(
		_internal.Icon,
		Object.assign(
			{
				dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`,
			},
			props,
			{
				size: 'medium',
			},
		),
	);
Presentation24Icon.displayName = 'Presentation24Icon';
var _default = (exports.default = Presentation24Icon);
